import { Component } from '@angular/core';
import { environmentCommon } from 'src/environments/environment-common';
import { URLS } from '../../../../data/navigation/navigation.data';

@Component( {
  selector: 'app-langmi-teacher-terms-page',
  templateUrl: './langmi-teacher-terms-page.component.html',
  styleUrls: [ './langmi-teacher-terms-page.component.scss' ]
} )
export class LangmiTeacherTermsPageComponent {

  URLS = URLS;

  environmentCommon = environmentCommon;

  constructor() {
    // Intentionally Blank
  }
}
